import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Por qué mi ansiedad es peor por la mañana?",
    answer:
      "La ansiedad matutina puede deberse a varios factores, incluido el ciclo natural del cortisol. Si los síntomas no mejoran con el tratamiento actual, una consulta con el equipo clínico puede ayudar.",
  },
];

export const esAnxietyWorseMorning = makeEsArticle({
  slug: "why-is-my-anxiety-worse-in-the-morning",
  title: "¿Por qué mi ansiedad es peor por la mañana?",
  description:
    "La ansiedad matutina puede deberse a varios factores. Si los síntomas no mejoran con el tratamiento, una consulta puede ayudar a evaluar opciones.",
  h1: "¿Por qué mi ansiedad es peor por la mañana?",
  breadcrumbLabel: "Ansiedad peor por la mañana",
  shortAnswer:
    "La ansiedad que es peor por la mañana puede deberse a varios factores, incluido el ritmo natural del cortisol y el patrón de síntomas de la depresión o la ansiedad. Si los síntomas no mejoran lo suficiente con el tratamiento actual, una consulta con el equipo clínico puede ayudar a evaluar opciones. SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos; no está indicada para la ansiedad por sí sola.",
  keyTakeaways: [
    "La ansiedad matutina puede deberse a varios factores.",
    "Puede influir el ritmo del cortisol.",
    "Si no mejora, una consulta puede ayudar.",
    "SAINT® no está indicada para la ansiedad por sí sola.",
    "SAINT® está autorizada por la FDA para el trastorno depresivo mayor en adultos.",
  ],
  sections: [
    {
      heading: "Ansiedad matutina",
      paragraphs: [
        "Algunas personas experimentan más ansiedad al despertar. Esto puede deberse al ritmo natural del cortisol, a la anticipación del día o a los patrones de síntomas de la depresión o la ansiedad. Si la ansiedad matutina persiste a pesar del tratamiento, conviene revisar el plan con un profesional.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
